import { Sparkles } from 'lucide-react';
import { joinCss, pickCss } from '@/shared/lib/css-utils';
import css from './agent-toggle-button.module.scss';

const styles = pickCss(css, css.root);

export type AgentToggleButtonProps = {
  className?: string;
  onClick: () => void;
  hasFreshSuggestions?: boolean;
  label?: string;
};

export const AgentToggleButton = ({
  className,
  onClick,
  hasFreshSuggestions = false,
  label = 'Open agent',
}: AgentToggleButtonProps) => (
  <button
    aria-label={label}
    className={joinCss(styles({ hasFreshSuggestions }), className)}
    onClick={onClick}
    type="button"
  >
    <Sparkles aria-hidden="true" size={18} />
    {hasFreshSuggestions ? (
      <span aria-hidden="true" className={css.dot} />
    ) : null}
  </button>
);
